const DetailsViewStyles = {
  card: {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    borderRadius: "12px",
    border: "1px solid #f0f0f0",
  },
  cardHead: {
    borderBottom: "1px solid #f0f0f0",
    fontSize: "16px",
    fontWeight: 600,
    color: "#262626",
  },
  textWithBreak: {
    whiteSpace: "normal",
    wordBreak: "break-word",
    width: "100%",
  },
  measurementTag: {
    padding: "4px 12px",
    backgroundColor: "#f6f8fa",
    borderRadius: "16px",
    fontSize: "12px",
    color: "#586069",
  },
  divider: {
    margin: "16px 0"
  },
  retailIdsContainer: {
    width: "100%"
  },
  addButton: {
    display: "flex", 
    alignItems: "center", 
    height: "24px",
    color: "#1890ff"
  },
  retailIdsWrapper: {
    display: "flex", 
    flexDirection: "column", 
    gap: "12px", 
    width: "55%"
  },
  retailIdRow: {
    display: "flex", 
    gap: "8px", 
    alignItems: "center",
    width: "100%"
  },
  retailIdInput: {
    flex: 1,
    borderRadius: "6px",
    height: "32px"
  },
  deleteButton: {
    color: "#ff4d4f",
    flexShrink: 0,
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  iconTooltip: {
    color: "#1890ff"
  }
};

export default DetailsViewStyles;